/**
* description:
* File of sNumberValidation Serivce
*
* Serwis jest odpowiedzialny za reużywalne funkcje pomocnicze.
*
* data : 2017-08-19
*/

const sNumberValidation = (() => {
  return {
    __checkNumberLength,
    __checkNumberCharacters,
    validateNumber,
  };
  // /// PRIVATE /////////////////////////////////////////////////////////////////
  /**
  * Metoda sprawdza długość numeru (domyślnie 9 znaków).
  *
  * @method __checkNumberLength(number, length)
  * @param {Integer} number - numer wpisany przez użytkownika
  * @param {Integer} length - maksymalna ilość znaków oczekiwanych w numerze
  * @return {Integer} zwraca 9 pierwszych cyfr z wpisanego numeru, resztę obcina
  * @access private
  */
  function __checkNumberLength(number, maxLength = 9) {
    return number.length > maxLength ? number.substring(0, maxLength) : number;
  }
  /**
  * Metoda sprawdza czy numer składa sie jedynie z cyfr, jeśli nie to usuwa te znaki.
  *
  * @method __checkNumberCharacters(number)
  * @param {Integer} number - numer wpisany przez użytkownika
  * @return {String} zwraca pusty znak jeśli wpisany znak nie jest cyfrą
  * @access private
  */
  function __checkNumberCharacters(number) {
    const _number = number === null ? '' : number;
    return _number.toString().replace(/[^0-9]/g, '');
  }
  // /// PUBLIC /////////////////////////////////////////////////////////////////
  /**
  * Metoda walidująca przekazany numer - sprawdza czy string składa się z samych cyfr
  * i określonej ilości znaków (domyślnie jest to 9 znaków).
  *
  * @method validateNumber(number, length)
  * @param {Integer} number - numer wpisany przez użytkownika
  * @param {Integer} length - maksymalna ilość znaków w numerze
  * @access public
  */
  function validateNumber(number, length) {
    return this.__checkNumberLength(this.__checkNumberCharacters(number), length);
  }
})();

export default sNumberValidation;



// WEBPACK FOOTER //
// ./src/services/sNumberValidation.js